import React from "react";
interface TableHeaderprops {
  data: any[];
}
const TableHeader = ({ children }: { children: React.ReactNode }) => {
  return <thead className=" h-14">{children}</thead>;
};

export default TableHeader;
